var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"main",class:_vm.b(),style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('video',{staticStyle:{"object-fit":"fill"},attrs:{"controls":"","autoplay":"","loop":"","width":_vm.width,"height":_vm.height,"src":_vm.dataChart.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }